var footerData = {
  social: [{
    id: 'facebook-footer',
    icon: 'ecs-font-icon-soc-facebook',
    label: 'Follow us on Facebook.',
    link: '//facebook.com/experian'
  }, {
    id: 'x-footer',
    icon: 'ecs-font-icon-soc-x',
    label: 'Follow us on X.',
    link: '//twitter.com/Experian_US'
  }, {
    id: 'inst-footer',
    icon: 'ecs-font-icon-soc-instagram',
    label: 'Follow us on Instagram.',
    link: '//instagram.com/experian'
  }, {
    id: 'youtube-footer',
    icon: 'ecs-font-icon-soc-youtube',
    label: 'Follow us on Youtube.',
    link: '//www.youtube.com/experian'
  }],
  mainCols: [{
    id: 'support-footer',
    column: 'Support',
    links: [{
      id: 'support-footer-1',
      link: '/help/credit-freeze/',
      title: 'Security freeze',
      linkType: 'product'
    }, {
      id: 'support-footer-2',
      link: '/help/fraud-alert/',
      title: 'Fraud alert',
      linkType: 'product'
    }, {
      id: 'support-footer-3',
      link: '/disputes/main.html',
      title: 'Disputes'
    }, {
      id: 'support-footer-4',
      link: '/reportaccess/',
      title: 'Denied credit'
    }, {
      id: 'support-footer-5',
      link: '/help/identity-theft-victim-assistance.html',
      title: 'Identity theft victim assistance'
    }, {
      id: 'support-footer-6',
      link: '/lp/military.html',
      title: 'Active duty military'
    }, {
      id: 'support-footer-7',
      link: '/blogs/ask-experian/credit-education/faqs/preapproved-credit-offers/opt-out/',
      linkType: 'blog',
      title: 'Opt out of prescreen offers'
    }, {
      id: 'support-footer-8',
      link: '/blogs/ask-experian/credit-education/faqs/experian-document-upload-service/',
      linkType: 'blog',
      title: 'Upload a document to Experian'
    }]
  }, {
    id: 'edu-footer',
    column: 'Education & advice',
    links: [{
      id: 'edu-footer-1',
      link: '/blogs/ask-experian/category/credit-advice/',
      title: 'Credit report & scores',
      linkType: 'blog'
    }, {
      id: 'edu-footer-2',
      link: '/blogs/ask-experian/category/fraud-and-identity-theft/',
      title: 'Fraud & identity theft',
      linkType: 'blog'
    }, {
      id: 'edu-footer-3',
      link: '/blogs/ask-experian/category/banking/',
      title: 'Banking',
      linkType: 'blog'
    }, {
      id: 'edu-footer-4',
      link: '/blogs/ask-experian/category/credit-cards/',
      title: 'Credit cards',
      linkType: 'blog'
    }, {
      id: 'edu-footer-5',
      link: '/blogs/ask-experian/category/loans/',
      title: 'Loans',
      linkType: 'blog'
    }, {
      id: 'edu-footer-6',
      link: '/blogs/ask-experian/category/insurance/',
      title: 'Insurance',
      linkType: 'blog'
    }, {
      id: 'edu-footer-7',
      link: '/blogs/ask-experian/category/personal-finance/mortgage/',
      title: 'Mortgage',
      linkType: 'blog'
    }, {
      id: 'edu-footer-9',
      link: '/blogs/ask-experian/category/personal-finance/investing/',
      title: 'Investing',
      linkType: 'blog'
    }, {
      id: 'edu-footer-8',
      link: '/blogs/ask-experian/category/personal-finance/',
      title: 'Personal finance',
      linkType: 'blog'
    }, {
      id: 'edu-footer-10',
      link: '/blogs/ask-experian/category/news-trends/research/',
      title: 'News & research',
      linkType: 'blog'
    }]
  }, {
    column: 'Credit resources',
    id: 'crd-footer',
    links: [{
      id: 'crd-footer-1',
      link: '/credit/credit-monitoring/',
      title: 'Free credit monitoring',
      linkType: 'product'
    }, {
      id: 'crd-footer-2',
      link: '/credit/experian-equifax-transunion-credit-report-and-score/',
      title: '3-bureau reports & FICO<sup>®</sup> Scores',
      linkType: 'product'
    }, {
      id: 'crd-footer-3',
      link: '/credit/credit-score/',
      title: 'Check credit',
      linkType: 'product'
    }, {
      id: 'crd-footer-4',
      link: '/credit/score-boost/',
      title: 'Improve credit',
      linkType: 'product'
    }, {
      id: 'crd-footer-5',
      link: '/credit/experian-go/',
      title: 'Establish credit',
      linkType: 'product'
    }, {
      id: 'crd-footer-7',
      link: '/protection/creditlock/',
      title: 'Experian CreditLock'
    }, {
      id: 'crd-footer-6',
      link: '/help/annual-credit-report.html',
      title: 'Annual credit report'
    }, {
      id: 'crd-footer-8',
      homepage: true,
      link: '/ncaconline/dispute',
      title: 'Credit file disclosure',
      attributes: {
        rel: 'nofollow'
      }
    }, {
      id: 'crd-footer-9',
      homepage: true,
      link: '/help/credit-score/',
      title: 'Credit score disclosure',
      linkType: 'product'
    }]
  }, {
    id: 'bus-footer',
    column: 'Experian for businesses',
    links: [{
      id: 'bus-footer-1',
      link: '/small-business/business-credit-reports',
      title: 'Business credit reports'
    }, {
      id: 'bus-footer-2',
      link: '/small-business/credit-profile',
      title: 'Customer credit profiles'
    }, {
      id: 'bus-footer-3',
      link: '/business/solutions/cloud-applications-platforms/decisioning-software',
      title: 'Decisioning software'
    }, {
      id: 'bus-footer-4',
      link: '/business/solutions/fraud-management',
      title: 'Business fraud management'
    }, {
      id: 'bus-footer-5',
      link: '/healthcare/',
      title: 'Healthcare solutions'
    }, {
      id: 'bus-footer-6',
      link: '/mortgage/',
      title: 'Mortgage solutions'
    }]
  }],
  legal: [{
    id: 'f-legal-1',
    link: '/corporate/legalterms',
    title: 'Legal terms & conditions'
  }, {
    id: 'f-legal-2',
    link: '/privacy/index',
    title: 'Privacy center'
  }, {
    id: 'f-legal-3',
    link: 'https://www.experian.com/privacy/us-consumer-data-privacy-policy',
    title: 'U.S. data privacy policy'
  }, {
    id: 'f-legal-4',
    link: '//www.experianplc.com/media/news',
    title: 'Press',
    target: '_blank',
    rel: 'noopener'
  }, {
    id: 'f-legal-5',
    link: '/privacy/opt-out-targeted-advertising',
    title: 'Ad choices',
    target: '_blank'
  }, {
    id: 'f-legal-6',
    link: '/careers/',
    title: 'Careers'
  }, {
    id: 'f-legal-7',
    link: '//www.experianplc.com/',
    title: 'Investor relations',
    target: '_blank',
    rel: 'noopener'
  }, {
    id: 'f-legal-8',
    link: '/contact/personal-services-contacts.html',
    title: 'Contact us'
  }]
};
export default footerData;